document.addEventListener("DOMContentLoaded", () => {
	const blocks = document.querySelectorAll('[sui-block="sui/timeline"]');

	blocks.forEach((block) => {
		if (block.hasAttribute("data-initialized")) return;
		block.setAttribute("data-initialized", "true");

		const progresBar = block.querySelector(".sui-timeline-progress");
		const timeline = Array.from(block.querySelectorAll(".sui-timeline-item"));

		if (!timeline.length) return;

		const lastEvent = timeline.at(-1);

		const getTriggerPoint = () => {
			return window.innerHeight / 2;
		};

		const getRect = (item) => {
			return item.getClientRects()[0];
		};

		const fixProgressTop = () => {
			const rect = timeline[0].getClientRects()[0];
			const start = rect.height / 2;
			progresBar.style.top = `${start}px`;
		};

		const updateProgress = () => {
			const trigger = getTriggerPoint();
			const rect = getRect(progresBar);
			const lastRect = getRect(lastEvent);
			const lastY = lastRect.y + lastRect.height / 2;

			let newTop = trigger - rect.y;
			newTop = newTop <= 0 ? 0 : newTop;

			if (lastY <= trigger) {
				newTop = Math.abs(lastY - rect.y);
			}

			progresBar.style.height = `${newTop}px`;
		};

		const checkTimeline = () => {
			const trigger = getTriggerPoint();

			timeline.forEach((event) => {
				const rect = getRect(event);

				if (rect.y + rect.height / 2 <= trigger) {
					event.classList.add("sui-active");
				} else {
					event.classList.remove("sui-active");
				}
			});
		};

		const updateAll = () => {
			fixProgressTop();
			checkTimeline();
			updateProgress();
		};

		window.addEventListener("scroll", () => {
			updateProgress();
			checkTimeline();
		});

		window.addEventListener("resize", () => {
			updateAll();
		});

		updateAll();
	});
});
